(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('default-market-session-settings', {
            parent: 'entity',
            url: '/default-market-session-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.defaultMarketSessionSettings.manageDefaultMarketSessionSettings" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/default-market-session-settings/default-market-session-settings.html',
                    controller: 'DefaultMarketSessionSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('defaultMarketSessionSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('default-market-edit', {
            parent: 'default-market-session-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-market-session-settings/default-market-session-settings-dialog.html',
                    controller: 'DefaultMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['DefaultMarket', 'GlobalValues', function(DefaultMarket, GlobalValues) {
                                     return DefaultMarket.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('default-market-session-settings-todolist', {
            parent: 'dashboard',
            url: '/defaultMarketSessionSEttings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-market-session-settings/default-market-session-settings-dialog.html',
                    controller: 'DefaultMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('default-market-session-settings', null, { reload: 'default-market-session-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('default-market-todolist-resubmit', {
            parent: 'dashboard',
            url: '/defaultMarketSettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-market-session-settings/default-market-session-settings-dialog.html',
                    controller: 'DefaultMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('default-market-session-settings', null, { reload: 'default-market-session-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('default-market-settings-auditLog', {
            parent: 'audit-log',
            url: '/defaultMarketSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-market-session-settings/default-market-session-settings-dialog.html',
                    controller: 'DefaultMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('default-market-session-settings', null, { reload: 'default-market-session-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('default-market-settings-historyReport', {
            parent: 'history-report',
            url: '/defaultMarketSettingsHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/default-market-session-settings/default-market-session-settings-dialog.html',
                    controller: 'DefaultMarketSessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('default-market-session-settings', null, { reload: 'default-market-session-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();
